import { Suspense, lazy } from 'react';
import { CustomSearchComponent, SearchProps } from './type';
import { SettingActionLoader } from '../../Loader';

const DefaultSearch: CustomSearchComponent = lazy(() => import('./DefaultSearch'));

const Search = ({ activeTab, customSearch }: SearchProps) => {
  if (customSearch === undefined || customSearch === false) {
    return null;
  }

  if (customSearch === true) {
    return (
      <Suspense fallback={<SettingActionLoader />}>
        <DefaultSearch key={activeTab} activeTab={activeTab} />
      </Suspense>
    );
  }

  const CustomSearch = customSearch;
  return <CustomSearch activeTab={activeTab} />;
};

export default Search;
